import { render } from "./CallScheme.vue?vue&type=template&id=17fc5f46"
import script from "./CallScheme.vue?vue&type=script&lang=js"
export * from "./CallScheme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__